const USER_KEY = "admin_user"

export function getAdminUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null")
  } catch (error) {
    return null
  }
}

export function saveAdminSession(token, user) {
  localStorage.setItem("admin_token", token)
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function updateAdminUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}))
}

export function clearAdminSession() {
  localStorage.removeItem("admin_token")
  localStorage.removeItem(USER_KEY)
}

export function hasAdminPermission(permissionCode) {
  if (!permissionCode) return true
  const user = getAdminUser()
  if (!user) return false
  if (user.superAdmin) return true
  return Array.isArray(user.permissions) && user.permissions.includes(permissionCode)
}
